import {
  Badge,
  EmptyState,
  ErrorBoundary,
  Modal,
  ModalBody,
  ModalHead,
} from '@dixa/lib-shared-habla';

import { createAppModal } from 'utils/modal';

import { InstrumentPanelTitle } from '../../../panel/components/panel/components/title/instrumentPanelTitle';
import { AnalyticsExport } from '../../analyticsExport';

import styles from './analyticsExportModal.module.scss';

export const AnalyticsExportModal = createAppModal(
  { type: 'analytics:export' },
  ({ isOpen, modal, hide }): JSX.Element => {
    const { instruments = [], panel } = modal.arg;

    return (
      <Modal isOpen={isOpen} onClose={hide} className={styles.modal}>
        <ModalHead
          title={
            <InstrumentPanelTitle
              panel={panel}
              prefix={
                <Badge variant="primary" size="medium">
                  Export
                </Badge>
              }
              data-analytics-panel={panel.id}
            />
          }
          onClose={hide}
        />

        <ModalBody>
          <ErrorBoundary
            fallback={
              <EmptyState
                title="Something went wrong"
                description="Data export is currently unavailable due to an unexpected
                error. Our team has been notified and is looking into the
                issue."
                icon="exclamation"
                iconColor="red.500"
                buttonProps={{
                  variant: 'primary',
                  children: 'Try reloading',
                  onClick: () => window.location.reload(),
                }}
              />
            }
          >
            <AnalyticsExport panel={panel} instruments={instruments} />
          </ErrorBoundary>
        </ModalBody>
      </Modal>
    );
  },
);
